export default defineAppConfig({
  ui: {
    colors: {
      primary: 'ocean',
      neutral: 'slate'
    },
    card: {
      slots: {
        root: 'dark:bg-item-bg dark:ring-border'
      }
    }

    // button: {
    //   base: 'disabled:opacity-100 flex justify-center',
    //   variant: {
    //     solid: 'dark:text-white dark:hover:bg-{color}-500'
    //   },
    //   default: {
    //     loadingIcon: 'eos-icons:loading'
    //   }
    // },

    // skeleton: {
    //   background: 'dark:bg-slate-900'
    // },

    // container: {
    //   constrained: 'max-w-[1440px]'
    // },

    // input: {
    //   color: { white: { outline: 'dark:bg-item-darkBg  dark:ring-border' } }
    // },

    // modal: {
    //   overlay: { background: 'dark:bg-black/30' }
    // },

    // popover: {
    //   background: 'dark:bg-item-bg'
    // },

    // select: { default: { color: 'purple' } },

    // selectMenu: {
    //   background: 'dark:bg-item-darkBg',
    //   option: {
    //     active: 'dark:bg-purple-950 '
    //   },
    //   input: 'dark:bg-ui-bg'
    // },

    // notification: {
    //   background: 'dark:bg-item-bg'
    // },

    // dropdown: {
    //   background: 'dark:bg-item-bg',
    //   item: {
    //     active: 'dark:bg-purple-dark'
    //   }
    // },

    // tabs: {
    //   list: {
    //     background: 'dark:bg-item-darkBg',
    //     marker: {
    //       background: 'dark:bg-purple-dark'
    //     }
    //   }
    // }
  }
})
